/*doc
---
title: Reading Challenge
name: reading_challenge
category: React
---

Displays a user's reading challenge. This component is used on the home page.

PROPS:

REQUIRED

* `challenge:title` : the name of the reading challenge
* `challenge:url` : the url of the reading challenge
* `challenge:year` : the year of the current reading challenge
* `challenge:id` : the id of the current reading challenge
* `challenge:type` : the type (yearly/group) of the current reading challenge
* `challenge:maxGoal` : the maximum goal a the current reading challenge can be set to
* `challenge:images:book` : url to the reading challenge book image used in the badge
* `challenge:images:completed` : url to the reading challenge completed sash overlay image
*
* OPTIONAL
*
* `goalNum` : how many books the has specified he/she will read in the challenge
* `numRead` : how many books the user has read in the challenge
* `isFinished` : whether the challenge is completed by the user or not
* `progressText` : message of whether the user is behind/ahead/on track in their challenge
*
```rails_example
<%= react_component 'ReactComponents.ReadingChallenge',
         {
           goalNum: 10,
           numRead: 5,
           isFinished: false,
           progressText: "You’re on track",
           challenge: {
             title: '2016 Reading Challenge',
             url: 'https://www.goodreads.com',
             year: 2016,
             id: 5555,
             type: 'y',
             maxGoal: 10000,
             images: {
               badge: "http://d.gr-assets.com/challenges/yearly/img_RCBook.svg"
               completed "http://d.gr-assets.com/challenges/yearly/img_RCCompleted.png"
             }
           }
         } %>
```
*/

import GrComponentFactory from "./gr_component_factory";
import GrPropTypes from "./shared/gr_prop_types";
import { fractionWithPercentage } from "../modules/number_formatting_utils";
import Reflux from "reflux";
import ProgressBar from "./progress_bar";
import ReadingChallengeEdit from "./reading_challenge_edit";
import ReadingChallengeBadge from "./reading_challenge/reading_challenge_badge";
import ReadingChallengeStore from "../react_stores/reading_challenge_store";

export default GrComponentFactory.createClass({
  displayName: "ReadingChallenge",
  mixins: [Reflux.connect(ReadingChallengeStore, "readingChallengeStore")],
  propTypes: {
    challenge: GrPropTypes.readingChallenge().isRequired,
  },

  renderBooksReadCount() {
    const state = this.state.readingChallengeStore;
    const urc_path = "/readingchallenges/annual"
    const readingChallengeUrl = state.enableUrcUpdates ? urc_path : state.userChallengeUrl;

    if (state.userChallengeUrl) {
      return <a href={readingChallengeUrl}
                  className="gr-hyperlink gr-hyperlink--naked">
                {this.renderBooksReadText()}
             </a>;
    } else {
      return this.renderBooksReadText();
    }
  },

  renderBooksReadText() {
    const state = this.state.readingChallengeStore;
    
    return (
      <div>
        <div className="readingChallengeStatusBox__bookCount">
          {state.numRead}
        </div>
        books completed
      </div>
    );
  },

  renderProgressMessage() {
    const state = this.state.readingChallengeStore;
    return (
      <div>
        {this.renderBooksReadCount()}
        <div className="readingChallengeStatusBox__message">
          <small>{state.progressText}</small>
        </div>
      </div>
    );
  },

  renderChallengeBadge() {
    const state = this.state.readingChallengeStore;
    const challenge = Object.assign({}, this.props.challenge,
      { isFinished: (state.startedChallenge && state.isFinished) }
    );

    return (
      <ReadingChallengeBadge challenge={ challenge }/>
    );
  },

  renderCongratsMessage() {
    const state = this.state.readingChallengeStore;
    const urc_path = "/readingchallenges/annual"
    const readingChallengeUrl = state.enableUrcUpdates ? urc_path : state.userChallengeUrl;

    return (
      <div>
        <div className="readingChallengeStatusBox__congrats">Congrats!</div>
        You have read{" "}
        <a href={readingChallengeUrl}
           className="gr-hyperlink">
          {state.numRead} books
        </a>
        {" "}of your goal of {state.goalNum}!
      </div>
    );
  },

  renderProgressBar() {
    const state = this.state.readingChallengeStore;
    return (
      <ProgressBar
        value={state.numRead}
        max={state.goalNum}
        width={70}
        bemModifiers="thick">
        <div className="u-defaultType u-inlineBlock u-marginLeftXSmall u-verticalAlignMiddle">
          {fractionWithPercentage(state.numRead, state.goalNum)}
        </div>
      </ProgressBar>
    );
  },

  renderChallengeLink() {
    return (
      <div className="u-marginTopXSmall">
        <a href={this.props.challenge.url}>View Challenge</a>
      </div>
    );
  },

  renderUserChallengeInfo() {
    const state = this.state.readingChallengeStore;
    return <div className="gr-mediaBox">
      <div className="gr-mediaBox__media u-marginRightMedium">
          { this.renderChallengeBadge() }
      </div>
      <div className="gr-mediaBox__desc">
        { state.isFinished ?
          this.renderCongratsMessage() :
          this.renderProgressMessage() }
        { this.renderProgressBar() }
        { this.renderChallengeLink() }
      </div>
    </div>;
  },

  render() {
    const state = this.state.readingChallengeStore;
    return (
      <div className="readingChallenge">
        <h3>{this.props.challenge.title}</h3>
        { state.startedChallenge ?
          this.renderUserChallengeInfo() :
          <ReadingChallengeEdit challenge={this.props.challenge}
                                booksToRead={state.booksToRead}
                                showLoadingSpinner={state.showLoadingSpinner}
                                enableUrcUpdates={state.enableUrcUpdates} /> }
      </div>
    );
  },
});
